<header>
  <h4 class="mb-4">Save As</h4>
</header>
<main class="d-flex align-items-stretch">
  <nav>
    <h5 class="nav-header">TXdocs Online</h5>
    <ul class="nav flex-column w-100">
      <li class="nav-item" *ngIf="!isDocumentAssembledWithoutCase()">
        <a
          href="#"
          (click)="changeComponent(openMenuItems.ClientCase)"
          class="nav-link"
          [ngClass]="{ active: activeComponent === openMenuItems.ClientCase }">
          <i class="bi-briefcase"></i>
          <span>Client Documents</span>
        </a>
      </li>
      <li class="nav-item">
        <a
          href="#"
          (click)="changeComponent(openMenuItems.Browse)"
          class="nav-link"
          [ngClass]="{ active: activeComponent === openMenuItems.Browse }">
          <i class="bi-folder"></i>
          <span>Firm Documents</span>
        </a>
      </li>
    </ul>
    <h5 class="nav-header">This PC</h5>
    <ul class="nav flex-column w-100">
      <li class="nav-item">
        <a
          href="#"
          (click)="changeComponent(openMenuItems.ThisPC)"
          class="nav-link"
          [ngClass]="{ active: activeComponent === openMenuItems.ThisPC }">
          <i class="bi-pc-display"></i>
          <span>Download</span>
        </a>
      </li>
    </ul>
  </nav>
  <div class="p-4 pt-2 overflow-auto flex-fill">
    <div
      class="mb-4 d-flex align-items-center gap-3"
      *ngIf="activeComponent == openMenuItems.ClientCase && selectedCaseId?.casID">
      <label>Selected Client:</label>
      <div class="flex-fill">
        <label class="fw-bold text-primary">
          <span>{{ document.ctcFirstName }} {{ document.ctcLastName }}</span>
        </label>
      </div>
    </div>
    <div class="mb-4 d-flex align-items-center gap-3" *ngIf="activeComponent == openMenuItems.ClientCase">
      <label>Selected Case:</label>
      <div class="flex-fill" *ngIf="selectedCaseId?.casID">
        <label class="fw-bold text-primary">{{ document.casDescription }}</label>
      </div>
      <div class="flex-fill">
        <tx-client-case-tree
          *ngIf="!selectedCaseId?.casID"
          [preselectedContactId]="preselectedContactId"
          [preselectedCaseId]="preselectedCaseId"
          (caseSelected)="onCaseSelected($event)"></tx-client-case-tree>
      </div>
    </div>
    <div class="d-flex gap-4" *ngIf="activeComponent != openMenuItems.ThisPC">
      <tx-file-type-selector
        class="flex-fill"
        [(fileName)]="filename"
        [defaultFileType]="defaultFileType"
        [disableFileType]="isPdf"></tx-file-type-selector>
      <button
        type="button"
        class="btn btn-primary ps-6 pe-6"
        [disabled]="isFilenameDuplicated() || isFilenameEmpty() || isCaseNotSelected()"
        (click)="onSaveClicked()">
        Save
      </button>
    </div>
    <ngb-alert type="danger" *ngIf="isFilenameDuplicated()" [dismissible]="false" class="p-3 ms-4 me-5">
      A file with that name already exists
    </ngb-alert>
    <ngb-alert type="danger" *ngIf="isFilenameEmpty()" [dismissible]="false" class="p-3 ms-4 me-5">
      The file name is empty
    </ngb-alert>
    <ngb-alert type="danger" *ngIf="isCaseNotSelected()" [dismissible]="false" class="p-3 ms-4 me-5">
      Please select a case
    </ngb-alert>
    <div *ngIf="isFilenameDuplicated()" class=""></div>

    <div [ngSwitch]="activeComponent" class="overflow-auto flex-fill pt-2">
      <tx-client-case-documents
        #clientCaseDocuments
        *ngSwitchCase="openMenuItems.ClientCase"
        [allowOpen]="false"
        (openDocument)="documentSelected($event)"
        (openInNewTab)="documentSelected($event)"
        [selectedCaseId]="selectedCaseId"
        [existingDocument]="existingDocument"
        [fileMenuAction]="fileMenuActions.SaveAs"></tx-client-case-documents>
      <tx-browse-documents
        #browseDocuments
        *ngSwitchCase="openMenuItems.Browse"
        [hideAssembledWithoutCaseFolder]="true"
        (theFolder)="setCurrentFolder($event)"
        [allowOpen]="false"
        [folderPath]="currentDocumentFolderPath"></tx-browse-documents>
      <tx-download-document
        *ngSwitchCase="openMenuItems.ThisPC"
        (downloadDocument)="downloadDocument($event)"></tx-download-document>
    </div>
  </div>
</main>
